document.addEventListener('DOMContentLoaded', () => {
    const modules = document.querySelectorAll('[data-js-module="newsletter"]');
    if (modules) {
        modules.forEach((moduleEl) => {
            new Newsletter(moduleEl).init();
        });
    }
});

class Newsletter {
    constructor(formElm) {
        this.formElm = formElm;
    }

    init() {
        this.inputFields = this.formElm.getElementsByTagName('input');
        this.submitButton = this.formElm.querySelector('[type="submit"]');
        this.loadingSpinner = this.formElm.querySelector('[data-js-spinner]');
        this.initEventListeners();
        this.updateToken();
    }

    async handleSubmit(event) {
        this.submitButton.setAttribute('disabled', true);
        this.loadingSpinner.classList.remove('opacity-0');

        const data = Object.fromEntries(new FormData(event.target).entries());
        const response = await fetch(this.formElm.action, {
            method: this.formElm.method,
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(data),
        });

        const json = await response.json();
        if (json.errors) {
            for (const error in json.error) {
                this.inputFields[error].classList.add('field-error');
            }
            this.loadingSpinner.classList.add('opacity-0');
            this.submitButton.removeAttribute('disabled');
            return;
        }

        // Succesfully signup
        setTimeout(() => {
            this.loadingSpinner.classList.add('opacity-0');
            const confirmationUrl = this.formElm.getAttribute('data-confirmation-url');
            if (confirmationUrl) {
                window.location = confirmationUrl;
            }
        }, 500);
    }

    initEventListeners() {
        this.formElm.addEventListener('submit', (event) => {
            event.preventDefault();
            this.handleSubmit(event);
        });

        for (const input of this.inputFields) {
            input.addEventListener('input', () => {
                input.classList.remove('field-error');
            });
        }
    }

    async updateToken() {
        const response = await fetch('/api/token/refresh', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        const json = await response.json();
        this.inputFields._token.value = json.token;

        // Refresh every 15 minutes.
        setTimeout(() => this.updateToken(), 15 * 60 * 1000);
    }
}
